var map = {
	"./views/apps/apps.module": [
		"./src/app/views/apps/apps.module.ts",
		"default~views-apps-apps-module~views-module_types-moduletypes-module~views-modules-modules-module",
		"views-apps-apps-module"
	],
	"./views/base/base.module": [
		"./src/app/views/base/base.module.ts",
		"views-base-base-module"
	],
	"./views/dashboard/dashboard.module": [
		"./src/app/views/dashboard/dashboard.module.ts",
		"default~views-dashboard-dashboard-module~views-stats-stats-module",
		"views-dashboard-dashboard-module"
	],
	"./views/module_types/moduletypes.module": [
		"./src/app/views/module_types/moduletypes.module.ts",
		"default~views-apps-apps-module~views-module_types-moduletypes-module~views-modules-modules-module",
		"views-module_types-moduletypes-module"
	],
	"./views/modules/modules.module": [
		"./src/app/views/modules/modules.module.ts",
		"default~views-apps-apps-module~views-module_types-moduletypes-module~views-modules-modules-module",
		"views-modules-modules-module"
	],
	"./views/stats/stats.module": [
		"./src/app/views/stats/stats.module.ts",
		"default~views-dashboard-dashboard-module~views-stats-stats-module",
		"views-stats-stats-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;